module.exports = __webpack_public_path__ + "static/8-005e1239de0549f93b344f510fb58cc1.jpeg";